import { makeIcon } from "components/ui/Icon";

export const SensitivityIcon = makeIcon(
  <svg fill="none" viewBox="0 0 16 16">
    <circle cx="8" cy="8" fill="currentColor" r="7" />
  </svg>,
);
